
import Vue from "vue";
import { MainProfilingService } from "@/services/main-profiling-service";

export default Vue.extend({
	data(){
		return {
			collectingHeap: false,
			collectingCpu: false,
			collectingGoRoutines: false,
			collectingGarbage: false
		};
	},
	methods: {
		async collectHeap(){
			this.collectingHeap = true;
			try{
				await MainProfilingService.getHeap();
			}catch(err){

			}
			this.collectingHeap = false;
		},
		async collectCpu(){
			this.collectingCpu = false;
			try{
				await MainProfilingService.getCPU();
			}catch(err){

			}
			this.collectingCpu;
		},
		async collectGoRoutines(){
			this.collectingGoRoutines = false;
			try{
				await MainProfilingService.getGoRoutine();
			}catch(err){

			}
			this.collectingGoRoutines;
		},
		async collectGarbage(){
			this.collectingGarbage = true;
			try{
				await MainProfilingService.gc();
			}catch(err){

			}
			this.collectingGarbage = false;
		}
	}
});
